import React from 'react'
import "./Button.css"

const Button = ({ text }) => {
    return (
        <>
            <button className='res_btn res_btn_anim1'>{text}</button>
        </>
    )
}

export default Button